import { ModalApi } from "components/modal/Modal";
import OnboardingModal from "components/modal/OnboardingModal";
import Button, { ButtonLevel, ButtonSize } from "components/ui/Button";
import Icon from "components/ui/Icon";
import { LinkButton } from "components/ui/Link";
import UILabel from "components/ui/UILabel";
import { AnimatePresence } from "motion/react";
import { useRef, useState } from "react";
import * as Styled from "./styled";

const OnboardingCta = ({ onSuccess }) => {
  const [showInfo, setShowInfo] = useState(false);
  const onboardingModal = useRef<ModalApi>(null);

  const toggleInfo = () => {
    setShowInfo((prev) => !prev);
  };

  const onClickGetStarted = async () => {
    onboardingModal.current?.show();
  };

  return (
    <>
      <Styled.Wrapper>
        <Styled.ToggleButton onClick={toggleInfo}>
          <Styled.ToggleInfo>
            <Styled.ToggleInfoIcon>
              <Icon name="dollars" color="secondary" />
            </Styled.ToggleInfoIcon>

            <Styled.ToggleInfoText>
              <UILabel.Medium bold>
                Start accessing your pay as you earn it.
              </UILabel.Medium>
            </Styled.ToggleInfoText>
          </Styled.ToggleInfo>

          <Styled.ToggleIcon $isToggled={showInfo}>
            <Icon name="chevronDown" color="secondary" size="xs" />
          </Styled.ToggleIcon>
        </Styled.ToggleButton>

        <AnimatePresence>
          {showInfo && (
            <Styled.InfoContainer
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: "auto" },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.33, ease: [0.25, 1, 0.5, 1] }}
            >
              <Styled.Info>
                <UILabel.Small>
                  Make your existing debit card work overtime for you. Just
                  verify your income to start spending as you earn.
                </UILabel.Small>

                <Styled.Actions>
                  <Button
                    size={ButtonSize.sm}
                    level={ButtonLevel.secondary}
                    onClick={onClickGetStarted}
                  >
                    Get Started
                  </Button>

                  <LinkButton onClick={toggleInfo} color="secondary" reverse>
                    Maybe later
                  </LinkButton>
                </Styled.Actions>
              </Styled.Info>
            </Styled.InfoContainer>
          )}
        </AnimatePresence>
      </Styled.Wrapper>

      <OnboardingModal ref={onboardingModal} onSuccess={onSuccess} />
    </>
  );
};

export default OnboardingCta;
